import PageAvatarInfo from "../components/UI/Avatar/PageAvatarInfo/PageAvatarInfo";
import CustomIcon from "../components/UI/CustomIcons/CustomIcon";
import ParkingAmountItem from "../components/UI/Items/dataTableItems/parkingAmountItem/ParkingAmountItem";
import ParkingDurationItem from "../components/UI/Items/dataTableItems/parkingDurationItem/ParkingDurationItem";
import ParkingTokenItem from "../components/UI/Items/dataTableItems/parkingTokenItem/ParkingTokenItem";
import SquareLabel from "../components/UI/Labels/SquareLabel";
import SitesPopover from "../components/UI/Popovers/SitesPopover/SitesPopover";
import UserScopesPopover from "../components/UI/Popovers/UserScopesPopover/UserScopesPopover";
import { LENGTHS } from "../config/Config";
import { ACTIVATION_TYPE, CAMPAIGN_TYPES, DISCOUNT_TYPE, PARKING_STATUSES, ROLES_NAMES, SCOPE_TYPE, UTRON_PLARFORMS, VALIDATION_TYPE, USER_TYPES } from "../enums/Enums";
import Colors from "../resources/Colors";
import Icons from "../resources/icons/Icons";
import Strings from "../resources/Strings";
import { getSiteIconName, getDistIconName, getDurationBetweenTwoDates, convertCurrencyToSymbol, convertUTCToLocalTime } from "./CommonUtils";

export const getUserData = (params) => {
  const row = params.row;
  const fullName = `${row.firstName || ""} ${row.lastName || ""}`;
  return (
    <PageAvatarInfo
      name={fullName}
      extraDeatil={row.email}
      image={row.image}
    ></PageAvatarInfo>
  );
};

export const getLableByParkingStatus = (params) => {
  let label = "";
  const mainCarToken = params.row?.mainCarToken;
  const isUserActive = params.row?.userSiteActivation?.isActive;
  const parkingStatus = mainCarToken?.parkingStatus;


  if (
    !mainCarToken ||
    !parkingStatus ||
    parkingStatus === PARKING_STATUSES.INACTIVE ||
    !isUserActive
  ) {
    label = (
      <SquareLabel
        text={Strings.PARKING_LABELS.INACTIVE}
        color={Colors.BLACK}
      ></SquareLabel>
    );
  } else if (parkingStatus === PARKING_STATUSES.IN) {
    label = (
      <SquareLabel
        text={Strings.PARKING_LABELS.IN}
        color={Colors.GREEN}
      ></SquareLabel>
    );
  } else if (parkingStatus === PARKING_STATUSES.OUT) {
    label = (
      <SquareLabel
        text={Strings.PARKING_LABELS.OUT}
        color={Colors.URTON_MAIN_COLOR}
      ></SquareLabel>
    );
  }

  return label;
};

export const getTime = (params) => {
  const parkingDeatils = params.row.mainCarToken?.parkingDeatils;
  if (parkingDeatils) {
    return (
      <ParkingDurationItem
        siteTimeZone={parkingDeatils.site.timeZone}
        entranceDate={parkingDeatils.entranceDate}
        retrievalDate={parkingDeatils.retrievalDate}
      />
    );
  }
};
export const getDuration = (params) => {
  const parkingDeatils = params.row.mainCarToken?.parkingDeatils;
  if (
    parkingDeatils &&
    parkingDeatils.retrievalDate &&
    parkingDeatils.entranceDate
  ) {
    return getDurationBetweenTwoDates(
      new Date(new Date(convertUTCToLocalTime(parkingDeatils.retrievalDate))?.toLocaleString('en-US', { hour12: true, timeZone: parkingDeatils.site?.timeZone})),
      new Date(new Date(convertUTCToLocalTime(parkingDeatils.entranceDate))?.toLocaleString('en-US', { hour12: true, timeZone: parkingDeatils.site?.timeZone}))
    );
  }
};

export const getAmount = (params) => {
  const invoiceSummary = params.row.mainCarToken?.invoiceSummary;

  return <ParkingAmountItem {...invoiceSummary} />;
};

export const getAmountValue = (params) => {
  let value = "";
  const invoiceSummary = params.row.mainCarToken?.invoiceSummary;
  if (invoiceSummary) {
    value = invoiceSummary?.finalPrice.toFixed(LENGTHS.TO_FIXED_LENGTH);
  }

  return value;
};

export const getAppIcon = (params) => {
  if (params.row) {
    return <CustomIcon addOpacity={!params.row.app} img={Icons.APP} />;
  }
};

export const getCampaignTypeIcon = (params) => {
  switch (params?.row?.campaignType || params?.Type) {
    case CAMPAIGN_TYPES.MOBILE:
      return <CustomIcon /*addOpacity={!params?.row?.app}*/ img={Icons.PHONE} />
    case CAMPAIGN_TYPES.MAIL:
      return <CustomIcon /*addOpacity={!params?.row?.app}*/ img={Icons.EMAIL} />
    
    default:
      break;
  }
}

export const getIconByScope = (sites, scope, className = '') => {
  switch (scope?.type) {
    case SCOPE_TYPE.GLOBAL:
      return <CustomIcon className={className} iconName={getSiteIconName(1)} />
    case SCOPE_TYPE.DISTRIBUTER:
      return <CustomIcon className={className} iconName={getDistIconName(1)} />
    case SCOPE_TYPE.PROJECT:
      const site = getSiteByScopeId(sites, scope.id);
      return <CustomIcon className={className} iconName={getSiteIconName(site ? site?.clientId : 1)} />   

    default:
      break;
  }
};

export const getToken = (params) => {
  if (params.row.mainCarToken) {
    return <ParkingTokenItem token={params.row.mainCarToken?.displayValue} />;
  }
};

export const getParkingLocations = (params) => {
  let parkingLocations = null;
  const utronUser = params.row.utronUser;
  let sites = null; 
  if (utronUser && utronUser?.userSites?.length > 0) {
    sites = utronUser.userSites.map((userSite) => {
      let userType = utronUser.userToUserTypes.find(
        (type) => type.userType.siteId === userSite.site.id
      )?.userType?.type;
      return { ...userSite.site, userType };
    });

    
  } else {
    const parkingDeatils = params.row?.mainCarToken?.parkingDeatils;
    if (parkingDeatils && parkingDeatils.site) {
      sites = [parkingDeatils.site];
    }
  }
  if (sites) {
    const sortedSites = getSortedUserSites(sites);
    parkingLocations = <SitesPopover sites={sortedSites}></SitesPopover>;
  }

  return parkingLocations;
};

export const getParkingLocationsBySites = (params) => {
  let sites = params.row.site;
  return <SitesPopover sites={sites}></SitesPopover>
};

export const getPhoneNumber = (params) => {
  let phoneNumber = "";
  if (params.row.phoneNumber && params.row.phoneNumber !== "Null") {
    return `+${params.row.phoneNumber}`
  }

  return phoneNumber;
};

export const getNotes = (params) => {
  let notes = "";
  if (params.row.userAdditionalData?.length > 0) {
    notes = params.row.userAdditionalData[0].notes !== null ? params.row.userAdditionalData[0].notes : "";
  }
  // support charge accounts area
  if (params.row.utronUser?.userAdditionalData?.length > 0) {
    notes = params.row.utronUser.userAdditionalData[0].notes !== null ? params.row.utronUser.userAdditionalData[0].notes : "";
  } 

  return notes;
};

export const getCarNumber = (params) => {
  if (params.row.mainCarToken && params.row.mainCarToken.car) {
    return params.row.mainCarToken.car?.licensePlate;
  }
};
export const getElectricIcon = (params) => {
  if (params.row.mainCarToken && params.row.mainCarToken.car) {
    return (
      <CustomIcon
        addOpacity={!params.row.mainCarToken.car.isEVSupported}
        img={Icons.Electric}
      />
    );
  }
};

export const getGmtUserData = (params) => {
  const utronUser = params.row?.utronUser;
  const fullName = `${utronUser?.firstName || ""} ${utronUser?.lastName || ""}`;
  return (
    <PageAvatarInfo name={fullName} image={utronUser?.image}></PageAvatarInfo>
  );
};

export const getChargeAccountData = (params) => {
  const utronUser = params.row?.utronUser || params.row?.chargeAccount.user.utronUser;
  const chargeAccountName = `${utronUser?.chargeAccount.name || utronUser?.chargeAccount || ""}`;
  return (
    <PageAvatarInfo name={chargeAccountName} image={utronUser?.image} isRow={true}></PageAvatarInfo>
  );
};

export const getContact = (params) => {
  const utronUser = params.row?.utronUser;
  let fullName = "";
  let phoneNumber = "";
  let email = "";
  if (utronUser?.firstName && utronUser?.lastName) {
    fullName = `${utronUser?.firstName} ${utronUser?.lastName}`;
    phoneNumber = `+${params.row?.phoneNumber}`;
    email = `${params.row?.email}`
  }

  return <div>{fullName}<br />{phoneNumber}<br />{email}</div>;
};

export const getValidation = (params) => {
  let selectedSite = params.row?.userSitesByScopes?.filter(us => us.id === params.row?.utronUser?.chargeAccount.siteId);
  let chargeAccountData = params.row?.utronUser?.chargeAccountData;
  let discountType = chargeAccountData?.discountType === DISCOUNT_TYPE.CURRENCY ? convertCurrencyToSymbol(selectedSite?.billingCurrency) : "%";
  let activationType = chargeAccountData?.isFullValidation ? ACTIVATION_TYPE.ACTIVE : ACTIVATION_TYPE.NON_ACTIVE;

  let partial = `${VALIDATION_TYPE.PARTIAL} `;
  partial += chargeAccountData?.discountType === DISCOUNT_TYPE.CURRENCY ? `${discountType}${chargeAccountData?.amount}` : `${chargeAccountData?.amount}${discountType}`;
  
  let full = `${VALIDATION_TYPE.FULL}: ${activationType}`;

  return <div>{partial}<br />{full}</div>;
};

export const getUserScopes = (params) => {
  // let parkingLocations = null;
  // //const userScopes = params.row?.userSitesByScopes.filter((site)=> params.row?.scopes.map((scope)=>scope.id)?.includes(site.scopeId));
  // const userScopes = params.row?.userSitesByScopes.filter((site) => params.row?.scopes.map((scope) => scope.id))?.filter(userSite => params.row.userScopes.some(userScope => userScope.scopeId === userSite.scopeId));
  // // const userScopes = params.row?.userSitesByScopes.filter((site) =>
  // //   params.row?.userScopes.map((scope) => scope.scopeId)?.includes(site.scopeId)
  // // );
  

  // if (userScopes && userScopes.length > 0) {
  //   const sites = userScopes.map((userSite) => {
  //     let userType = params.row?.userScopes.find(
  //       (scope) => scope.scopeId === userSite.scopeId
  //     )?.role?.name;
  //     return { ...userSite, userType };
  //   });
  //   parkingLocations = <SitesPopover sites={sites}></SitesPopover>;
  // }

  // return parkingLocations;

  return <UserScopesPopover userScopes={params.row?.userScopes} />
};

export const getCurrentSites = (sites, currentUsersScopes) => {
  let currentSites = sites.filter(site => currentUsersScopes.some(currentUsersScope => currentUsersScope.id === site.scopeId));
  return currentSites;
};

export const getSitesUnderSelectedScope = (sites, scopes, selectedScope) => {
  let filteredSitesByScopes = [];

  switch (selectedScope?.type) {
    case SCOPE_TYPE.GLOBAL:
      filteredSitesByScopes = sites.filter(site => scopes.some(scope => scope.id === site.scopeId));
      break;
    case SCOPE_TYPE.DISTRIBUTER:
      filteredSitesByScopes = sites.filter(site => scopes.some(scope => scope.id === site.scopeId && scope.parentId === selectedScope.id));
      break;
    case SCOPE_TYPE.PROJECT:
      filteredSitesByScopes = sites.filter(site => site.scopeId === selectedScope.id); 
      break;
    
    default:
      break;
  }

  return filteredSitesByScopes;
}

// sorts sites and scopes names together by userScopes
export const getSortedUserScopes = (sites, userScopes) => {
  return [...userScopes]?.sort((a, b) => {
    // combines site displayName and scope name
    // if no site displayName founded takes the scope name
    const nameA = getSiteByScopeId(sites, a.scopeId) ? getSiteByScopeId(sites, a.scopeId)?.displayName : a.scope.name || "";
    const nameB = getSiteByScopeId(sites, b.scopeId) ? getSiteByScopeId(sites, b.scopeId)?.displayName : b.scope.name || "";
    
    return nameA.localeCompare(nameB);
  });
}

// sorts sites by displayName
export const getSortedUserSites = (sites) => {
  return [...sites]?.sort((a, b) => {
    const nameA = a?.displayName || "";
    const nameB = b?.displayName || "";
    
    return nameA.localeCompare(nameB);
  });
}

export const getUserSitesBySiteId = (sites, siteId) => {
  let site = sites.find(site => site.id === siteId);
  if (site) {
    return site.userSites;
  }
};

export const getScopeIdBySiteId = (sites, siteId) => {
  let site = sites.find(site => site.id === siteId);
  if (site) {
    return site.scopeId;
  }
};

export const getCustomerRoleId = (roles) => {
  let role = roles.find(role => role.name === ROLES_NAMES.CUSTOMER);
  if (role) {
    return role.id;
  }
};

// used in ScopesSelectInput
export const getSiteByScopeId = (sites, scopeId) => {
  sites = sites.find(site => site.scopeId === scopeId);
  if (sites) {
    return sites;
  }
};

export const getScopeByScopeId = (scopes, scopeId) => {
  scopes = scopes.find(scope => scope.id === scopeId);
  if (scopes) {
    return scopes;
  }
};

export const getSiteFromSiteId = (sites, siteId) => {
  let site = sites.find(site => site.id === siteId);
  if (site) {
    return site;
  }
};

export const getUserTypeFromUserTypeId = (userTypes, userTypeId) => {
  let userType = userTypes.find(userType => userType.id === userTypeId);
  if (userType) {
    return userType;
  }
};

export const getRole = (roles, roleName) => {
  let role = roles?.find(role => role?.name === roleName);
  if (role) {
    return role;
  }
};

export const getRoleByRoleId = (roles, roleId) => {
  let role = roles?.find(role => role?.id === roleId);
  if (role) {
    return role;
  }
};

export const getChargeAccountsData = (chargeAccounts, accountsDict) => {
  // attach for every chargeAccount, its chargeAccountData under utronUser data
  let chargeAccountData = {};
  let updatedChargeAccounts = [];
  
  chargeAccounts.forEach((acc) => {
    if (accountsDict[acc.utronUser?.id]?.some(data => data.chargeAccount.userId === acc.utronUser?.id)) {
      // check that it is the same userId acc
      let accUtronUserCopy = {...acc.utronUser};
      let accCopy = {...acc};
      let isFullValidation = accountsDict[acc.utronUser.id]?.some(data => data.discount?.isFullDiscount);
      let amount;
      let discountType;
      let id;

      accountsDict[acc.utronUser?.id]?.forEach(ctd => {
        if (!ctd?.discount?.isFullDiscount) {
          amount = ctd?.discount?.discountAmount;
          discountType = ctd?.discount?.discountType;
          id = ctd?.discount?.id;
        }
      });

      chargeAccountData = {
        isFullValidation,
        amount,
        discountType
      };

      // attach data
      accUtronUserCopy.chargeAccountData = chargeAccountData;
      accCopy.utronUser = {...accUtronUserCopy};
      updatedChargeAccounts.push(accCopy);
    }   
  });
  
  return updatedChargeAccounts
};

export const getSelectionModelByFlatUser = (flatUserObj, selectedSites) => {
  // flatUserObj - receives flat user obj, adds the missing properties for the ui
  // selectedSites - needed for checking if user is active in the site selected 
  flatUserObj.identityId = flatUserObj.id; // for update usage
  flatUserObj.firstName = flatUserObj.utronUser?.firstName;
  flatUserObj.lastName = flatUserObj.utronUser?.lastName;
  flatUserObj.image = flatUserObj.utronUser?.image;
  flatUserObj.userAdditionalData = flatUserObj.utronUser?.userAdditionalData;

  // handles the activate / disactivate menu item
  flatUserObj.userSiteActivation = flatUserObj.utronUser?.userSites.find(
    (userSite) => selectedSites.some(site => userSite.siteId === site.id)
  );

  // handles the app icon near the image
  flatUserObj.app = flatUserObj.userToPlatforms.some(
    (platform) => platform.platformId === UTRON_PLARFORMS.MOBILE
  );

  return flatUserObj;
};

// filters the scopes list selection and removes scopes with customer role by checking with current connected user's userScope
export const getFilteredScopesList = (scopes, roles, loggedInUserIdentityId) => {
  let dict = {};
  let globalScope;
  let distributerScope;
  let allowAllScopes = false;
  let allowDistributerScopes = false;
  let filteredScopesList = [];
  let customerScopes = [];
  let customerRole = getRole(roles, ROLES_NAMES.CUSTOMER); 
  let filteredRoles = roles?.filter(role => role.name !== ROLES_NAMES.CUSTOMER && role.name !== ROLES_NAMES.INACTIVE); // (all roles except customer and inactive)
  if (customerRole) {
    scopes.forEach(scope => {
      dict[scope.id] = scope;
      let relevantUserScope = scope?.userScopes?.find(us => us.userId === loggedInUserIdentityId && us.roleId === customerRole.id);
      if (relevantUserScope) {
        customerScopes.push(scope);
      }
      if (scope.scopeLevel === 0) {
        // if user has any roles that is not customer or inactive on global scope, allow to show all scopes
        allowAllScopes = scope.userScopes.some(us => us.userId === loggedInUserIdentityId && filteredRoles.some(fr => fr.id === us.roleId));
        globalScope = scope;
      }
      if (scope.scopeLevel === 1) {
        // if user has any roles that is not customer or inactive on distributer scope, allow to show all scopes under that scope
        allowDistributerScopes = scope.userScopes.some(us => us.userId === loggedInUserIdentityId && filteredRoles.some(fr => fr.id === us.roleId));
        distributerScope = scope;
      }
    });
    if (!globalScope) {
      customerScopes.forEach(cs => {
        if (cs.scopeLevel > 1 && !dict[cs.parentId]) {
          dict[cs.id] = null;
        }
      });
    }
    if (allowAllScopes) {
      return scopes;
    }
    if (allowDistributerScopes) {
      for (let [key, value] of Object.entries(dict)) {
        if ((value !== null && value.id === distributerScope.id) || (value !== null && value.parentId === distributerScope.id)) {
          // handle scopes under distributer & distributer scope
          filteredScopesList.push(value);
        }
        else if (value !== null && value.userScopes.some(us => us.userId === loggedInUserIdentityId && filteredRoles.some(fr => fr.id === us.roleId))) {
          // handle also project scope if has permission
          filteredScopesList.push(value);
        }
      }

      return filteredScopesList;
    }
    else {
      // once reached here (user doesnt have permission to global or distributer), 
      // handle every project scope on its own, 
      // for every project scope check if has role permission to be on the list (scopes dropdown list)
      // (not customer or inactive)
      for (let [key, value] of Object.entries(dict)) {
        if (value !== null && value.userScopes.some(us => us.userId === loggedInUserIdentityId && filteredRoles.some(fr => fr.id === us.roleId))) {
          filteredScopesList.push(value);
        }
      }
      return filteredScopesList;
    } 
  }
  else {
    return scopes;
  }
};

export const isUserSubscribed = (utronUser) => {
   // (users with userAdditionalData and isMessagingEnabled)
   return utronUser?.userAdditionalData?.length > 0 && utronUser?.userAdditionalData?.[0]?.isMessagingEnabled;

   // for debug users with firstName & lastName null null:
   //return utronUser?.userAdditionalData.length === 0 || utronUser?.userAdditionalData.length > 0 && utronUser?.userAdditionalData?.[0]?.isMessagingEnabled;
};

export const isUserActiveBySites = (user, selectedSites, roles) => {
  // Check which user is received and get the indications
  const isTransient = user?.utronUser?.userSites?.length === 0 && user?.utronUser?.userToUserTypes?.some(ut => ut?.userTypeId === USER_TYPES.TRANSIENT);
  const isGmtUser = user?.utronUser?.userSites?.length === 0 && user?.utronUser?.userToUserTypes?.length === 0

  // Check on user that he doesnt have any 'Inactive' userScope on the selectedSites
  const userActiveByUserScopes = !user?.userScopes?.some(us => selectedSites?.some(sel => sel.scopeId === us.scopeId && getRoleByRoleId(roles, us.roleId)?.name === ROLES_NAMES.INACTIVE));

  // Check on user that he has userSites on the selectedSites and it is active
  const userActiveByUserSites = user?.utronUser?.userSites?.some(us => selectedSites?.some(sel => sel.id === us.siteId && us.isActive));
  
  // Transient - should have no userSites
  // Gmt user - should have any userScopes except inactive role on the selectedSites (see userActiveByUserScopes)
  // Parker - should have userSites active - true - on the selectedSites (see userActiveByUserSites)
  // Gmt user that is also a parker - should have any userScopes except inactive role on the selectedSites & should have userSites active - true - on the selectedSites

  if (isTransient) {
    return user?.utronUser?.userSites?.length === 0;
  }
  else if (isGmtUser) {
    return userActiveByUserScopes;
  }
  else {
    return userActiveByUserScopes && userActiveByUserSites;
  }
};

export const isUserHasGlobalAdminRole = (userScopes, allScopes, roles) => {
  const adminRole = getRole(roles, ROLES_NAMES.ADMINISTRATOR);
  const userHasGlobalAdminRole = userScopes?.some(us => {
    let foundedScope = getScopeByScopeId(allScopes, us.scopeId);
    if (foundedScope?.type === SCOPE_TYPE.GLOBAL && us?.roleId === adminRole?.id) {
      // if founded check if has admin role on global scope
      return true;
    }

    return false;
  });

  return userHasGlobalAdminRole;
};

export const isAllowedForAdminArea = (userScopes, selectedScope, allScopes, roles) => {
  let isAllowed = false;
  const adminRole = getRole(roles, ROLES_NAMES.ADMINISTRATOR);
  const userHasGlobalAdminRole = isUserHasGlobalAdminRole(userScopes, allScopes, roles);
  
  // global - once user has admin for global
  // admin area will be visible for every selectedScope
  // if theres no global admin role for the user, check by any scope on its own
  if (selectedScope?.type === SCOPE_TYPE.GLOBAL || selectedScope?.type === SCOPE_TYPE.PROJECT) {
    isAllowed = userHasGlobalAdminRole || userScopes?.some(us => us?.scopeId === selectedScope?.id && us?.roleId === adminRole?.id);
  }
  // distributer - check by any scope on its own, or check by parentId
  if (selectedScope?.type === SCOPE_TYPE.DISTRIBUTER) {
    isAllowed = userHasGlobalAdminRole || userScopes?.some(us => (us?.scopeId === selectedScope?.id || us?.scopeId === selectedScope?.parentId) && us?.roleId === adminRole?.id);
  }

  return isAllowed;
};

// hierarchy role check between the connected user and the selected user to make actions on
// example: collaborator can't make actions on administrator user
export const isAllowedForActionsOnUser = (roles, selectionModel, connectedUser) => {
  const customerRole = getRole(roles, ROLES_NAMES.CUSTOMER);
  const viewerRole = getRole(roles, ROLES_NAMES.VIEWER);
  const connectedUserRole = connectedUser?.role;

  const isAllowed = selectionModel?.userScopes?.some(us => {
    let foundedRole = getRoleByRoleId(roles, us.roleId);

    // compare role hierarchies,
    // and all roles can make actions on customer except Viewer
    return connectedUserRole?.hierarchy <= foundedRole?.hierarchy || (connectedUserRole.id !== viewerRole.id && us.roleId === customerRole.id);   
  });

  return isAllowed;
};